import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Construction, ArrowLeft } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';

export default function ComingSoon({ pageName }) {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-900 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center gap-2 text-orange-500 mb-2">
            <Construction className="h-6 w-6" />
            <CardTitle>Page Under Modernization</CardTitle>
          </div>
          <CardDescription>
            {pageName} is being migrated to the new architecture
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-slate-600 dark:text-slate-400">
            This page is temporarily unavailable while we upgrade it to use:
          </p>
          <ul className="text-sm text-slate-600 dark:text-slate-400 space-y-1 list-disc list-inside">
            <li>React 18 + Hooks</li>
            <li>shadcn/ui components</li>
            <li>Tailwind CSS 4.x</li>
            <li>Modern state management</li>
          </ul>
          <Button onClick={() => navigate('/summary')} className="w-full">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
